import React, { useEffect, useState } from "react";
import { getDownloadUrl, s3KeyFromUrl } from "../api";

interface SecureImageProps {
  src: string;
  alt?: string;
  className?: string;
}

export default function SecureImage({ src, alt = "", className }: SecureImageProps) {
  const [resolvedSrc, setResolvedSrc] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setResolvedSrc(null);
    getDownloadUrl(s3KeyFromUrl(src))
      .then(url => { if (!cancelled) setResolvedSrc(url); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [src]);

  if (!resolvedSrc) {
    return <div className={className + " bg-gray-100 animate-pulse"} />;
  }
  return <img src={resolvedSrc} alt={alt} className={className} />;
}
